export const PAWTUCKET_FLIGHTS_MODULE_ID = "ptFlightsModule";
